import React, { Component } from "react";
import LachakToranjTabItems from "./rugPartsTabs/lachakToranj";
import AfshanTabItems from "./rugPartsTabs/afshan";
import KheshtiTabItems from "./rugPartsTabs/kheshti";
import ModernTabItems from "./rugPartsTabs/modern";

export default class RugPartsPanelTabs extends Component {
  render() {
    switch (this.props.globalState.activeCarpetType) {
      case "lachak-toranj":
        return (
          <LachakToranjTabItems
            texts={this.props.texts}
            activePartsTab={this.props.globalState.activePartsTab}
            partsTabHandler={this.props.partsTabHandler}
          />
        );
      case "afshan":
        return (
          <AfshanTabItems
            texts={this.props.texts}
            activePartsTab={this.props.globalState.activePartsTab}
            partsTabHandler={this.props.partsTabHandler}
          />
        );
      case "kheshti":
        return (
          <KheshtiTabItems
            texts={this.props.texts}
            activePartsTab={this.props.globalState.activePartsTab}
            partsTabHandler={this.props.partsTabHandler}
          />
        );
      case "modern":
        return (
          <ModernTabItems
            texts={this.props.texts}
            activePartsTab={this.props.globalState.activePartsTab}
            partsTabHandler={this.props.partsTabHandler}
          />
        );
      default:
        return(<div></div>);
        break;
    }
  }
}
